
import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CampaignMiniBanner from '../../components/feature/CampaignMiniBanner';
import TeaHero from './components/TeaHero';
import TeaCampaignBanner from './components/TeaCampaignBanner';
import TeaStory from './components/TeaStory';
import TeaCategories from './components/TeaCategories';
import TeaBrewingGuide from './components/TeaBrewingGuide';
import TeaColdBrewGuide from './components/TeaColdBrewGuide';
import TeaPlans from './components/TeaPlans';
import TeaLifestyle from './components/TeaLifestyle';
import TeaReviews from './components/TeaReviews';
import TeaSubscribeForm from './components/TeaSubscribeForm';
import TeaCTA from './components/TeaCTA';

export default function TeaPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar scrolled={scrolled} />
      <div className="pt-16 sm:pt-20">
        <CampaignMiniBanner />
      </div>
      <main>
        <TeaHero />
        <TeaCampaignBanner />
        <TeaStory />
        <TeaCategories />
        <TeaBrewingGuide />
        <TeaColdBrewGuide />
        <TeaPlans />
        <TeaLifestyle />
        <TeaReviews />
        <TeaSubscribeForm />
        <TeaCTA />
      </main>
      <Footer />
    </div>
  );
}
